import { CreditCardData, BinInformation, InstallmentPlanInformation } from './interfaces';
import { fetchToken, fetchBinInformation, fetchInstallmentsPlan } from './lib';

function dlocal(apiKey: string) {
    async function createToken(data: CreditCardData): Promise<{ token: string } | { error: string }> {
        return fetchToken(apiKey, data);
    }
    async function getBinInformation(bin: string, country: string): Promise<BinInformation> {
        return fetchBinInformation(apiKey, bin, country);
    }
    async function getInstallmentsPlan(amount: number, currency: string, country: string, bin: string): Promise<InstallmentPlanInformation> {
        return fetchInstallmentsPlan(apiKey, amount, currency, country, bin);
    }
    return { createToken, getBinInformation, getInstallmentsPlan };
}

window.dlocal = (apiKey: string) => dlocal(apiKey);
